<template>
  <div class="body">
    <el-container>
      <!-- <ProductsAside /> -->
      <el-main style="overflow: inherit">
        <div class="p-3">
          <el-row :gutter="10">
            <el-col :xl="6" :lg="6" :md="12" :sm="12">
              <div class="searchForm">
                <label for="search"></label>
                <el-input
                  placeholder="بحث باسم المنتج"
                  @keyup.native="filterByName"
                  autofocus
                  type="text"
                  v-model="productName"
                  @focus="$event.target.select()"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="6" :sm="12">
              <div class="searchForm">
                <label for="code"></label>
                <el-input
                  placeholder="بحث باسم الكود"
                  autofocus
                  @keyup.native="filterByCode"
                  type="text"
                  @focus="$event.target.select()"
                  v-model="searchCode"
                ></el-input>
              </div>
            </el-col>
            <el-col :lg="2" :pull="14">
              <el-button
                type="success"
                icon="el-icon-printer"
                @click="printAllProducts"
              ></el-button>
            </el-col>
          </el-row>
        </div>
        <el-table
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          v-infinite-scroll="loadMoreData"
          style="overflow: auto; width: 100%"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <!-- <el-table-column sortable width="90" label="الكود" prop="product.id">
          </el-table-column> -->
          <el-table-column width="250" label="اسم المنتج" prop="product.name">
          </el-table-column>
          <el-table-column width="400" label="ملاحظات" prop="note">
          </el-table-column>
          <el-table-column width="90" label="الكميه" prop="qty">
          </el-table-column>
          <el-table-column width="90" label="الوحده" prop="unit">
          </el-table-column>
          <el-table-column width="200" label="التاريخ" prop="created_at">
          </el-table-column>

          <el-table-column sortable label="بواسطة" prop="user.name">
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import ProductsAside from "@/components/ProductsAside.vue";
// import { ipcRenderer } from "electron";
export default {
  name: "DamagedProductReport",
  // components: { ProductsAside },
  data() {
    return {
      stock: "",
      editFormVisible: false,
      tableData: [],
      allData: [],
      selectedProduct: null,
      productCategories: [],
      name: "",
      searchCode: "",
      productName: "",
      selectedCategory: "",
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      activeSide: true,
    };
  },
  created() {
    this.getDamagedkProducts();
  },
  methods: {
    getDamagedkProducts() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `products/interval-damaged-report/1?page=${this.pagination.current_page}`;
      axiosApi
        .get(url)
        .then((res) => {
          res.data.history.map((item) => {
            this.tableData.push(item);
          });
          this.pagination = res.data.meta;
          localStorage.setItem(
            "damagedProductReport",
            JSON.stringify(this.tableData)
          );
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    loadMoreData() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getDamagedkProducts();
      }
    },
    getCategories() {
      axiosApi
        .get("product-categories")
        .then((res) => {
          this.productCategories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    filterByName() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let newData = [];
      let outStockProuducts = JSON.parse(
        localStorage.getItem("damagedProductReport")
      );
      if (this.productName !== "") {
        for (let index = 0; index < outStockProuducts.length; index++) {
          if (outStockProuducts[index].product.name.match(this.productName)) {
            newData.push(outStockProuducts[index]);
          }
        }
      } else {
        newData = outStockProuducts;
      }
      this.tableData = newData;
      loading.close();
    },
    filterByCode() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let newData = [];
      let outStockProuducts = JSON.parse(
        localStorage.getItem("damagedProductReport")
      );
      if (this.searchCode !== "") {
        for (let index = 0; index < outStockProuducts.length; index++) {
          if (
            outStockProuducts[index].product.id
              .toString()
              .match(this.searchCode)
          ) {
            newData.push(outStockProuducts[index]);
          }
        }
      } else {
        newData = outStockProuducts;
      }
      this.tableData = newData;
      loading.close();
    },
    printAllProducts() {
      // window.ipcRenderer = ipcRenderer;
      // let search = "";
      // if (this.productName !== "") {
      //   search = this.productName;
      // } else if (this.searchCode !== "") {
      //   search = +this.searchCode;
      // }
      // let data = {
      //   data: this.tableData,
      //   type: "productDamagedReport",
      //   searchKey: search,
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 90%;
  overflow-y: scroll;
}
</style>
